// generated by recipeyak.api.base.codegen
import { http } from "@/apiClient"

export function memberList(params: { team_id: number }) {
  return http<
    Array<{
      id: number
      created: string
      level: "admin" | "contributor" | "read"
      user: {
        id: number
        name: string | null
        avatar_url: string
        email: string
      }
    }>
  >({
    url: "/api/v1/t/{team_id}/members/",
    method: "get",
    params,
    pathParamNames: ["team_id"],
  })
}
